export class EmpDetails {
  public employeeName: string;
  public emailId: string;
  public employeeId: string;
  public reportingManager: boolean;
  public reportingManagerId: string;
  public reportingManagerName: string;
  public role: string;
  public editMode: boolean;
  public team: boolean;
  constructor(data: any) {
    this.employeeName = data.employeeName ? data.employeeName : "";
    this.emailId = data.emailId ? data.emailId : "";
    this.employeeId = data.employeeId ? data.employeeId : "";
    this.reportingManager = data.Role
      ? data.Role == "RM"
        ? true
        : false
      : false;
    this.reportingManagerId = data.RMCode ? data.RMCode : "";
    this.reportingManagerName = data.RMname ? data.RMname : "";
    this.editMode = data.editMode ? data.editMode : false;
    this.role = data.reportingManager ? "RM" : "EMP";
    this.team = data.team ? data.team : "";
  }
}

export class projectDetails {
  public projectName: string;
  public projectType: string;
  public wbsCode: string;
  public programName: string;
  public projectManager: string;
  public empName: string;
  public departmentInfo: any[];
  public employess: any;
  public startDate: any;
  public endDate: any;
  public plannedHours: any;
  public actualHours: any;
  public editMode: boolean;
  public originalstartDate: any;
  public originalendDate: any;
  constructor(data: any) {
    this.projectName = data.projectName ? data.projectName : "";
    this.wbsCode = data.wbsCode ? data.wbsCode : "";
    this.programName = data.programName ? data.programName : "";
    this.projectManager = data.projectManager ? data.projectManager : "";
    this.empName = data.empName ? data.empName : "";
    this.departmentInfo = data.dataInfo ? data.dataInfo : [];
    this.plannedHours = data.plannedHour ? data.plannedHour : 0;
    this.startDate = data.startDate ? data.startDate : "";
    this.endDate = data.endDate ? data.endDate : "";
    this.editMode = data.editMode ? data.editMode : false;
    this.originalstartDate = data.originalstartDate
      ? data.originalstartDate
      : {};
    this.originalendDate = data.originalendDate ? data.originalendDate : {};
  }
}

export class projectList {
  public Project: string;
  public createdDate: string;
  public startDate: string;
  public endDate: string;
  public startFormattedDate: string;
  public endFormattedDate: string;
  public originalstartDateobj: any = { formatted: "" };
  public originalendDateobj: any = { formatted: "" };
  public arrowclicked: boolean = false;
  public editMode: boolean = false;
  public empDetails: any;
  public projectID: any;
  public plannedHour: any;
  public spentTotal: any;
  constructor(data: any) {
    this.Project = data.Project.Project ? data.Project.Project : "";
    this.projectID = data.Project.projectID ? data.Project.projectID : "";

    this.startDate = data.Project.startDate
      ? data.Project.startDate.split("T")[0]
      : "";
    this.endDate = data.Project.endDate
      ? data.Project.endDate.split("T")[0]
      : "";
    this.startFormattedDate = this.convertDateFormat(this.startDate);
    this.endFormattedDate = this.convertDateFormat(this.endDate);
    this.originalstartDateobj.formatted = this.startFormattedDate
      ? this.startFormattedDate
      : "";
    this.originalendDateobj.formatted = this.endFormattedDate
      ? this.endFormattedDate
      : "";
    this.empDetails = data.empDetails;
    this.spentTotal = data.totalTimePerproject ? data.totalTimePerproject : "";
    this.plannedHour = data.Project.plannedHour ? data.Project.plannedHour : "";
  }
  convertDateFormat(date) {
    return date.split("-").reverse().join("-");
  }
}

export class EmpList {
  public employeeName: string;
  public emailId: string;
  public employeeId: string;
  public empno_legacy: string;
  public projectCount: number;
  public editMode: boolean;
  public Role: string;
  public RMCode: string;
  public RMname: string;
  public isManager: string;
  public team: string;
  public RMEmailID:string;
  constructor(data: any) {
    const empData = data.employeeDetails;
    this.employeeName = empData.Empname ? empData.Empname : "";
    this.emailId = empData.EmailID ? empData.EmailID : "";
    //this.employeeId = empData.Empno ? empData.Empno : "";
    this.empno_legacy = empData.Empno_legacy ? empData.Empno_legacy : "";
    this.projectCount = data.projectCount ? data.projectCount : 0;
    this.editMode = empData.editMode ? empData.editMode : false;
    this.Role = empData.Role ? empData.Role : "";
    //this.RMCode = empData.RMCode ? empData.RMCode : "";
    this.RMEmailID=empData.Manager_Email_Id ? empData.Manager_Email_Id:"";
    this.RMname = empData.RMname ? empData.RMname : "";
    this.isManager = this.Role.toUpperCase() == "RM" ? "Yes" : "No";
    this.team = empData.Team ? empData.Team : "";
  }
}


export class EmpListforReport {
  public employeeName: string;
  public emailId: string;
  public employeeId: string;
  public empno_legacy: string;
  public projectCount: number;
  public editMode: boolean;
  public Role: string;
  public RMCode: string;
  public RMname: string;
  public isManager: string;
  public jobTitle:string;
  public team: string;
  public RMEmailID:string;
  public Lplus2name:string;
  public Lplus2_EmailID:string;
  public EmpDepartment:string;
  public daysFilled:Number;
  public HoursFilled:Number;
  constructor(data: any) {
    const empData = data.employeeDetails;
    this["Employee Name"] = empData.Empname ? empData.Empname : "";
    this["Employee Id	"] = empData.Empno_legacy ? empData.Empno_legacy : "";
    this["Email Id"] = empData.EmailID ? empData.EmailID : "";
    this["Job title"]=empData.JobTitle ? empData.JobTitle:"";
    this["RMname"] = empData.RMname ? empData.RMname : "";
    this["RM EmailID"]=empData.Manager_Email_Id ? empData.Manager_Email_Id:"";
    this["L+2 name"]=empData.L_Plus_2_name?empData.L_Plus_2_name:"";
    this["L+2 EmailID"]=empData.L_Plus_2?empData.L_Plus_2:"";
    this["Role"] = empData.Role ? empData.Role : "";
    this["EmpDepartment"]=empData.EmpDepartment?empData.EmpDepartment:"";
    this.projectCount = data.projectCount ? data.projectCount : 0;
    this.daysFilled=data.daysSubmitted ?data.daysSubmitted:0;
    this.HoursFilled=data.totalHours?data.totalHours:0
  }
}


export class LockedList {
  public employeeName: string;
  public employeeId: string;
  public action: string;
  public days: any;
  public checked: Boolean;
  public comment: string;
  constructor(data: any) {
    this.employeeName = data.Empname ? data.Empname : "";
    this.employeeId = data.Empno ? data.Empno : "";
    this.action = data.lockedDetails.isLocked ? "Unlock" : "Lock";
    this.days = this.getDiffDays(data.lockedDetails.lockedDate);
    this.checked = data.checked ? data.checked : false;
    this.comment = data.unlockRequest.comment ? data.unlockRequest.comment : "";
  }
  getDiffDays(date) {
    var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    var firstDate = new Date(date);
    var secondDate = new Date();

    var diffDays = Math.round(
      Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
    );
    return diffDays;
  }
}

export class Notification {
  public id: string;
  public date: string;
  public message: string;
  public type: boolean = false;
  public reason: string;
  constructor(data: any) {
    this.id = data.notificationid ? data.notificationid : "";
    this.date = data.notificationdate
      ? this.convertDate(data.notificationdate)
      : "";
    this.message = data.message ? data.message : "";
    this.type = data.type ? data.type : "";
    this.reason = data.reason ? data.reason : "-";
  }
  convertDate(dateObject) {
    let date = new Date(dateObject);
    return (
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.interface.ts